import { useState, useEffect } from "react";
import Button from "./Button";
import { connect, useDispatch, useSelector } from "react-redux";
import { CLOSE_DIALOGUE } from "../store/dialogue/dialogue.type";
import { FormControl, TextField, MenuItem, Select } from "@mui/material";
import { createReward, editReward } from "../store/reward/reward.action";

const AddrewardAds = (props) => {
  const dispatch = useDispatch();
  const [adName, setAdName] = useState("");
  const [coins, setCoins] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [underSubmisson, setUnderSubmission] = useState(false);
  const [adNameError, setAdNameError] = useState("");
  const [coinsError, setCoinsError] = useState("");

  const { dialogueData } = useSelector((state) => state.dialogue);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!adName) {
      setAdNameError("Category Name is required");
      return;
    }
    if (!coins) {
      setCoinsError("Coins is required");
      return;
    }
    if (dialogueData) {
      const data = { adName, coins, isActive };
      setUnderSubmission(true);
      props.editReward(data, dialogueData._id);
    } else {
      const data = { adName, coins: parseInt(coins), isActive };
      setUnderSubmission(true);
      props.createReward(data);
    }
    setUnderSubmission(false);
    handleClose();
  };
  useEffect(() => {
    if (dialogueData) {
      setAdName(dialogueData?.adName);
      setIsActive(dialogueData?.isActive ? true : false);
      setCoins(dialogueData?.coins.toString());
    }
  }, [dialogueData]);

  const handleClose = () => {
    dispatch({
      type: CLOSE_DIALOGUE,
      payload: {
        dialogue: false,
      },
    });

    let dialogueData_ = {
      dialogue: false,
    };
    localStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };
  return (
    <>
      <div
        className="row search-action"
        style={{
          paddingRight: "3px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "16px",
        }}
      >
        <div className="col-12 col-lg-6 col-md-6 col-sm-12 ">
          <div
            className={`prime-input search-input-box  m-0`}
            sx={{
              borderRadius: "62px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{ fontSize: "25px", fontWeight: "500", color: "unset" }}
            >
              {dialogueData ? "Edit Ads" : "Add Ads"}
            </label>
          </div>

          <Button
            btnName={"Back"}
            newClass={"back-btn"}
            onClick={handleClose}
          />
          <form onSubmit={handleSubmit}>
            <FormControl
              sx={{
                m: 2,
                minWidth: 120,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                label="Ad Name"
                value={adName}
                onChange={(e) => setAdName(e.target.value)}
                error={adNameError}
                sx={{
                  width: "100%",
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "9999px",
                    border: "none",
                    "& fieldset": {
                      // Target the outline
                      border: "none",
                    },
                    "&:hover fieldset": {
                      borderWidth: "1px",
                    },
                    "&.Mui-focused fieldset": {
                      borderWidth: "1px",
                    },
                  },
                }}
              />
              <TextField
                id="outlined-basic"
                label="Reward Coins"
                value={coins}
                onChange={(e) => setCoins(e.target.value)}
                error={coinsError}
                sx={{
                  width: "100%",
                  mb: 1,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "9999px",
                    "& fieldset": {
                      // Target the outline
                      border: "none",
                    },
                    "&:hover fieldset": {
                      borderWidth: "1px",
                    },
                    "&.Mui-focused fieldset": {
                      borderWidth: "1px",
                    },
                  },
                }}
              />
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={isActive}
                onChange={(e) => setIsActive(e.target.value)}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  width: "100%",
                  borderRadius: "9999px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "9999px", // Make the input fully rounded
                    padding: "8px 16px", // Adjust padding for a better look
                  },
                  "& .MuiSelect-select": {
                    borderRadius: "9999px",
                  },
                }}
              >
                <MenuItem value={true}>Active</MenuItem>
                <MenuItem value={false}>Deactive</MenuItem>
              </Select>
              <Button
                newClass={"submit-btn-dialogue py-2"}
                type={"submit"}
                disabled={underSubmisson}
                btnName={dialogueData ? "Update" : "Create"}
                style={{ marginRight: "10px" }}
              />
            </FormControl>
          </form>
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  createReward,
  editReward,
})(AddrewardAds);
